module.exports = __webpack_public_path__ + "img/1.73d38c46.png";